export function formatCurrency(
  amount: number | string,
  currency: string,
  locale?: string
): string {
  const num = typeof amount === "string" ? parseFloat(amount) : amount
  if (isNaN(num)) return "—"
  const l = locale || "en-GB"
  try {
    return new Intl.NumberFormat(l, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num)
  } catch {
    return `${currency} ${num.toFixed(2)}`
  }
}

export function formatCompact(amount: number | string, currency: string): string {
  const num = typeof amount === "string" ? parseFloat(amount) : amount
  if (isNaN(num)) return "—"
  if (num >= 1000000) return `${currency} ${(num / 1000000).toFixed(1)}M`
  if (num >= 1000) return `${currency} ${(num / 1000).toFixed(1)}K`
  return formatCurrency(num, currency)
}
